<template>
  <div class="home" @scroll="better_scrollHome">
    <header>
      <div class="bg pic-full"></div>
    </header>
    <main class="main">
      <title-content/>
      <menu-bar :list="list" :active="active" :chainBtnFixed="chainBtnFixed" @scrollHome="scrollHome" />
      <side-bar :list="list" :active="active" />
      <main-content
        :dapps="list.find(item=>item.section===active).dapps"
        @selectDApp="selectDApp"
      />
      <qrcode-popup v-if="showPopup" :selectedDApp="selectedDApp" />
    </main>
  </div>
</template>

<script>
// @ is an alias to /src
import MenuBar from '@/components/menu-bar'
import SideBar from '@/components/side-bar'
import TitleContent from '@/components/title-content'
import MainContent from '@/components/main-content'
import list from '@/assets/json/index.json'
import QrcodePopup from "@/components/qrcode-popup";
import throttle from '@/utils/throttle'

export default {
  name: 'Home',
  components: {
    QrcodePopup,
    MenuBar,
    SideBar,
    TitleContent,
    MainContent
  },
  data() {
    return {
      list: list,
      active: list[0].section,
      showPopup: false,
      selectedDApp: undefined,
      hideTop: false,
      chainBtnFixed: false,
      scrollTimer: undefined,
      canSlide: false,
      emitTop: window.document.documentElement.clientWidth * 1.5053,
      emitTop1_pc: window.document.documentElement.clientWidth * 0.135,
      emitTop1_mobile: window.document.documentElement.clientWidth * 0.596
    }
  },
  mounted() {
    // window.onscroll = () => {
    //   const emitTop = window.document.documentElement.clientWidth * 0.13958
    //   const currentTop = window.document.documentElement.scrollTop
    //   if (currentTop >= emitTop && !this.hideTop) {
    //
    //   }
    // }
  },
  methods: {
    selectDApp(dapp) {
      this.selectedDApp = dapp
      this.showPopup = true
    },
    scrollHome() {
      const emitTop1 = this.device === 'pc' ? this.emitTop1_pc : this.emitTop1_mobile
      clearTimeout(this.scrollTimer)
      const scrollTop = document.getElementsByClassName('home')[0].scrollTop
      this.chainBtnFixed = this.emitTop < scrollTop
      if (scrollTop > emitTop1 - 1) this.canSlide = true
      this.scrollTimer = setTimeout(()=>{
        if(scrollTop < emitTop1 && scrollTop > 0 && this.canSlide) {
          document.getElementsByClassName('home')[0].scrollTo({
            top: emitTop1,
            behavior: "smooth"
          })
        } else if (scrollTop < emitTop1) {
          this.canSlide = false
        }
      },200)
    },
    better_scrollHome: throttle(function () {
      this.scrollHome()
    },100),
  },
}
</script>
<style lang="less">
.home {
  position: relative;
  height: 100vh;
  overflow-y: scroll;
  color: #101010;

  .main {
    position: relative;
  }
}
@media screen and (min-width: 767px) {
  .bg {
    width: 17.38rem;
    height: 2.68rem;
    background-image: url("../assets/img/pc/bg.png");
    margin: 0 auto;
  }
}

@media screen and (max-width: 767px) {
  .bg {
    width: 7.5rem;
    height: 4.47rem;
    background-image: url("../assets/img/mobile/bg.png");
    margin: 0 auto;
  }
}
</style>
